enum TypeCharge {
  Generator = 0,
  Lighting = 1,
  BatteryCharger = 2,
  OfficeEquipement = 3,
  LinearLoad = 4,
  NoLinearLoad = 5,
  UPS = 6,
  MedicalEquipment = 7,
  Welder = 8,
  Motor = 9,
  AirConditioner = 10,
  FirePump = 11,
  Elevator = 12,
  ATS = 13,
  Transformer = 14,
  CircuitBreaker = 15
}
export default TypeCharge
